import React from 'react';
import Header from './Header';
import './Layout.css'; // 👈 Make sure this is imported
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <>
      <div className="headerContainer">
        <Header />
      </div>
      <main className="pageWrapper">
        <Outlet />
      </main>
    </>
  );
};

export default Layout;
